import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import "ol/ol.css";
import XYZ from "ol/source/XYZ";
import { _projection, _selectedMapSettings } from "../../../config";

export const MyMap = new Map({
  layers: [
    new TileLayer({
      name: "Uydu Görüntüsü",
      zIndex: 0,
      source: new XYZ({
        url: "http://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      }),
    }),
  ],
  target: null,
  view: new View({
    extent: _selectedMapSettings.extent,
    center: _selectedMapSettings.center || [0, 0],
    zoom: _selectedMapSettings.zoom || 1,
    projection: _projection,
  }),
});
